import type { ReactElement } from 'react';
import { useTranslation } from '../i18n/useLanguage.js';

export function Spinner(): ReactElement {
  return <span className="spinner" role="presentation" />;
}

export function LoadingBlock({ label }: { label?: string }): ReactElement {
  const t = useTranslation();
  return (
    <div className="loading-block" role="status">
      <Spinner />
      <span>{label ?? t.common.loading}</span>
    </div>
  );
}
